import styled from 'styled-components';

export const PricingWrapper = styled.div`
   display: flex;
   flex-direction: row;
   justify-content: left;
   flex-grow: 1;
   margin-bottom: 30px;
`;

export const Table = styled.table`
   width: 100%;
   .heading {
      padding-right: 50px;
      color: #848484;
   }

   input {
      width: auto;
      padding: 10px;
      border: 1px solid #f0f0f0;
      font-size: 15px;

      &:disabled {
         color: #848484;
         background: #e1e0e0;
      }
   }
`;
